import { render, staticRenderFns } from "./Cfg.vue?vue&type=template&id=c8f0efa2&scoped=true&"
import script from "./Cfg.vue?vue&type=script&lang=js&"
export * from "./Cfg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8f0efa2",
  null
  
)

export default component.exports